import React, { useMemo } from 'react';
import gold from 'asset/img/gold.svg';
import './index.scss';

/**
 * 宝箱奖励弹窗内容组件 - 与 Detail / Menu 共用
 * @param {number} coin - 金币数量
 * @param {object} [food] - 可选，65% 概率开出的食物 { goods_id, name, image }
 */
const TreasureBoxModal = ({ coin, food }) => {
    const boxContent = useMemo(() => (
        <div
            className='detail-box-modal box-modal-open'
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                padding: food ? '32px 24px 40px' : '40px 24px',
                position: 'relative',
                overflow: 'hidden',
                minHeight: food ? '320px' : '280px',
                boxSizing: 'border-box',
            }}
        >
            {/* 金币区域 */}
            <div
                className='box-coin-icon-large'
                style={{
                    width: '60px',
                    height: '60px',
                    marginBottom: '16px',
                    position: 'relative',
                    zIndex: 1,
                    flexShrink: 0,
                }}
            >
                <img
                    src={gold}
                    alt="金币"
                    style={{ width: '60px', height: '60px', objectFit: 'contain' }}
                />
            </div>
            <div
                className='box-coin-number-large'
                style={{
                    color: '#FF4444',
                    fontSize: '4.5rem',
                    fontWeight: 900,
                    lineHeight: 1,
                    marginBottom: '14px',
                    textAlign: 'center',
                    position: 'relative',
                    zIndex: 1,
                    flexShrink: 0,
                    letterSpacing: '-2px',
                }}
            >
                {coin}
            </div>
            <div
                className='box-text-simple'
                style={{
                    fontSize: '2.2rem',
                    color: '#FF6B35',
                    fontWeight: 800,
                    lineHeight: 1.4,
                    textAlign: 'center',
                    position: 'relative',
                    zIndex: 1,
                    flexShrink: 0,
                    letterSpacing: '2px',
                }}
            >
                获得{coin}枚金币
            </div>

            {/* 食物区域：65% 概率展示，带稀有惊喜文案 */}
            {food && food.image && (
                <div className='treasure-box-food-row'>
                    <div className='treasure-box-food-rare-label'>✨ 哇！运气爆棚！稀有奖励！</div>
                    <div className='treasure-box-food-main'>
                        <img
                            src={food.image}
                            alt={food.name}
                            className='treasure-box-food-icon'
                        />
                        <span className='treasure-box-food-text'>
                            获得 {food.name} x1
                        </span>
                    </div>
                </div>
            )}

            <div className='box-flash-effect' />
        </div>
    ), [coin, food]);

    return boxContent;
};

export default TreasureBoxModal;
